import React from "react";
import {
  Link,
} from "react-router-dom";
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as timelineAction from '../action/timelineAction';
import * as partnerAction from '../action/partnerAction';
import * as footprintAction from '../action/footprintAction';
import * as lightboxAction from '../action/lightboxAction';
import * as favoriteAction from '../action/favoriteAction';
import * as myPostGoodUserAction from '../action/myPostGoodUserAction';
import * as helpAction from '../action/helpAction';
//Material-ui
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
//Add
import moment from 'moment';
import { LazyLoadImage } from 'react-lazy-load-image-component';
//Func
import { lsTimelineConditionInit } from '../func/lsTimelineCondition';
import atom2datetime from '../func/atom2datetime';
//Part
import PartUserName from './PartUserName';
import PartUserMainImg from './PartUserMainImg';
import PartPagingNextPrev from './PartPagingNextPrev';
import PartTimelineFootprint from './PartTimelineFootprint';
import PartPostGood from './PartPostGood';

//Dialog
import DialogQaAnswerAddConfirm from './DialogQaAnswerAddConfirm';
import DialogMyPostGoodUser from './DialogMyPostGoodUser';
import DialogConfirm from './DialogConfirm';
import DialogTimelineCondition from './DialogTimelineCondition';

//Icon
import CancelIcon from '@material-ui/icons/Cancel';
import RefreshIcon from '@material-ui/icons/Refresh';
import MoreVertSharpIcon from '@material-ui/icons/MoreVertSharp';
import FilterListIcon from '@material-ui/icons/FilterList';
import FeaturedPlayListOutlinedIcon from '@material-ui/icons/FeaturedPlayListOutlined';
//img
import Blank from '../img/blank/blank-1x1.gif';
import Blank2x1 from '../img/blank/blank-2x1.gif';

class Comp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      myPostGoodUserId: null,
      qaAnswerAddQaId: null,
      qaAnswerAddText: '',
      qaAnswerDelQaId: null,
      dialogTimelineCondition: false,
      timelineEditPic: null,
      timelineEditAnchor: null,
    }

    if (!localStorage.getItem('TimelineCondition')) {
      lsTimelineConditionInit();
    }
  }

  componentDidMount() {
    let datetime = new Date();
    if ((datetime - this.props.timeline.datetime) > (5*60*1000)) {
      this.props.timelineListGet(this.props.timeline.page);
    }
  }

  _onPaging(page) {
    this.props.timelineListGet(page);
    let elem = document.getElementById('timeline_block');
    let rect = elem.getBoundingClientRect();
    window.scrollTo(0, (window.pageYOffset + rect.top - document.getElementById('header_menu').clientHeight));
  }

  _renderTitle(type, value, text) {
    if (type === 'single') {
      return (
        <div
          style={{
            display:'flex',
            flexDirection:'row',
            alignItems: 'center',

          }}
        >
          <div style={{flex:1}}>
            <div style={{padding:'2%'}}>
              <div style={{display:'flex',flexDirection:'row',justifyContent:'start'}}>
                <div style={{padding:'3px'}}>
                  <Link to={{ pathname: '/partner/' + value.userdata_id_code}}>
                    <PartUserMainImg
                      mainImg={value.userdata_mainImg}
                      width={'50px'}
                      height={'50px'}
                      radius={'50%'}
                    />
                  </Link>
                </div>
                <div>
                  <div>
                    <Link to={{ pathname: '/partner/' + value.userdata_id_code}}>
                      <PartUserName
                        data={{
                          name: value.userdata_name,
                          sex: value.userdata_sex,
                          size: '1.2em',
                        }}
                      />
                    </Link>
                    <span style={{fontWeight:'bold'}}>
                      さん({value.userdata_age}才 {value.userdata_prof_region})が{ text }
                    </span>
                  </div>
                  <div>
                    <div style={{color:'#666'}}>{atom2datetime(value.date_atom, 'D')}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <IconButton
              onClick={ (event) => this.setState({timelineEditPic:value.userdata_id_code, timelineEditAnchor:event.currentTarget}) }
            >
              <MoreVertSharpIcon />
            </IconButton>
          </div>
        </div>

      )
    }
    else if (type === 'multi') {
      return (
        <div
          style={{
            display:'flex',
            flexDirection:'row',
            alignItems: 'center',
          }}
        >
          <div style={{flex:1}}>
            <div style={{padding:'2%'}}>
              <div>
                <div style={{fontWeight:'bold'}}>{ text }</div>
                <div style={{color:'#666'}}>
                  {atom2datetime(value.date_atom, 'D')}
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    }
  }

  _render(value, index) {
    let title;
    let contents;

    if (value.type === "partnerFootprint") {
      title = this._renderTitle('multi', value, value.footprint_count + "件の足あと");
      contents = (
        <div>
          <div style={{padding:'2%'}}>
            <PartTimelineFootprint
              list={value.list}
            />
            {
              (value.isListNext) && (
                <div align='center'>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={ () => this.props.timelineFootprintListGet(value.date, value.page + 1)}
                  >
                    足あとを見る
                  </Button>
                </div>
              )
            }
          </div>
        </div>
      )
    }
    else if (value.type === "myPostGood") {
      title = this._renderTitle('multi', value, '投稿に「いいね」がありました');

      let postCommentArr = value.post_comment.split(',');

      contents = (
        <div>
          <div style={{padding:'2%'}}>
            {
              postCommentArr.map((item, index, arr) => {
                let postItemArr = item.split(':');

                return (
                  <div key={index}>
                    <div style={{color:'#666'}}>{moment(postItemArr[1]).format("YYYY年MM月DD日")}の投稿</div>
                    <div style={{
                      width:'100%',
                      whiteSpace:'nowrap',
                      overflow:'hidden',
                      textOverflow:'ellipsis'
                    }}>
                      {postItemArr[2]}
                    </div>
                    <Button
                      variant="outlined"
                      onClick={ () => this.props.myPostGoodUserListGet(postItemArr[0], 1, () => {}) }
                    >
                      いいねを押した会員
                    </Button>
                  </div>
                );
              })
            }
          </div>
        </div>
      )
    }
    else if (value.type === "post") {
      title = this._renderTitle('single', value, '投稿しました');

      contents = (
        <div>
          <div style={{padding:'2%'}}>
            <div style={{whiteSpace: 'pre-line'}}>
              {value.post_comment}
            </div>
          </div>
          {
						(Array.isArray(value.post_photo_arr) === true) &&
						value.post_photo_arr.map((value, index, arr) => {

              let photoList = arr.map(function(value, index) {
                return {src: arr[index].uri + "&W=600&H=600&blur=0&crop=0"};
              });

          		if (((arr.length) % 2) === 1 & index === 0) {
          			return (
          				<div key={index} style={{display:'inline-block', width:'100%'}}>
          					<div
                      style={{margin:'1px', position:'relative', cursor:'pointer'}}
                      onClick={ () => this.props.lightboxOpen(photoList, index) }
                    >
                      <LazyLoadImage
                        src={value.uri + "&W=600&H=300&blur=0&crop=1"}
                        style={{width:"100%", height: "auto", boxSizing:'border-box'}}
                        placeholder={<img src={Blank2x1} style={{width:"100%", height: "auto",}} alt='' />}
                        alt=''
                      />

                      <img
                        src={Blank}
                        style={{
                          position: 'absolute',
                          left:0,
                          top:0,
                          width:'100%',
                          height:'100%',
                        }}
                        alt=''
                      />
          					</div>
          				</div>
          			);
          		}
          		else {
          			return (
          				<div key={index} style={{display:'inline-block', width:'50%'}}>
                    <div
                      style={{margin:'1px', position:'relative', cursor:'pointer'}}
                      onClick={ () => this.props.lightboxOpen(photoList, index) }
                    >
                      <LazyLoadImage
                        src={value.uri + "&W=300&H=300&blur=0&crop=1"}
                        style={{width:"100%", height: "auto", boxSizing:'border-box'}}
                        placeholder={<img src={Blank} style={{width:"100%", height: "auto",}} alt='' />}
                        alt=''
                      />

                      <img
                        src={Blank}
                        style={{
                          position: 'absolute',
                          left:0,
                          top:0,
                          width:'100%',
                          height:'100%',
                        }}
                        alt=''
                      />
                  	</div>
          				</div>
          			);
          		}
            })
					}
          <div style={{padding:'2%'}}>
						<PartPostGood
							click={ () => this.props.partnerPostGoodEdit(value.userdata_id_code, value.id, () => {}) }
							goodCount={value.post_good_count}
              goodCountNondisplay={value.post_good_count_nondisplay}
						  goodSended={value.post_good_sended}
						/>
          </div>
        </div>
      );
    }
    else if (value.type === "qaQuestion") {

      title = this._renderTitle('single', value, 'Q&Aを作成しました');

      contents = (
        <div style={{padding:'2%'}}>
          <div style={{margin:'5px',fontWeight:'bold',color:'#666'}}>
            Q. {value.qa_question}
          </div>
          <div style={{margin:'5px'}}>
            {
              (value.qa_answered) ? (
                <div>
                  <span className='orange_icon'>回答済み</span>
                  {value.qa_answered}
                  <CancelIcon
                    onClick={ () => this.setState({qaAnswerDelQaId:value.id}) }
                    style={{
                      verticalAlign:'middle',
                      cursor:'pointer',
                      color:'#ccc',
                    }}
                  />
                </div>
              ) :
              (Array.isArray(value.qa_answer) === true) &&　(
                value.qa_answer.map( (answer, index) => {
                  return (
              			<div key={index} style={{margin:'5px'}}>
                      <Button
                        size="large"
                        variant="outlined"
                        style={{textAlign:'left'}}
                        onClick={ () => this.setState({qaAnswerAddQaId:value.id, qaAnswerAddText:answer }) }
                      >
                        { answer }
                      </Button>

              			</div>
              		)
                })
              )
            }
          </div>
        </div>
      );

    }
    else if (value.type === "qaAnswer") {

      title = this._renderTitle('single', value, 'Q&Aに回答しました');

      contents = (
        <div style={{padding:'2%'}}>
          <div style={{margin:'5px',fontWeight:'bold',color:'#666'}}>
            Q. {value.qa_question}
          </div>
          <div style={{margin:'5px'}}>
            {
              (Array.isArray(value.qa_answer) === true) && (
                value.qa_answer.map(
                  (value, index) => {return (<div key={index} style={{color:'#666'}}>A. {value}</div>)}
                )
              )
            }
          </div>
          <div style={{margin:'5px'}}>
            <span className='orange_icon'>回答</span> {value.qa_answered}
          </div>
          {
            (value.qa_answered_cnt > 1) && (
              <div style={{margin:'5px'}}>
                <div style={{color:'#666'}}>その他Q&Aに{ value.qa_answered_cnt - 1 }件回答しています</div>
                <Link to={{ pathname: '/partner/' + value.userdata_id_code}}>
                  <Button
                    variant="outlined"
                    color="primary"
                  >
                    プロフィールからもっとみる
                  </Button>
                </Link>
              </div>
            )
          }
        </div>
      );
    }
    else if (value.type === "profile") {

      title = this._renderTitle('single', value, 'プロフを編集しました');

      let comment;
      if (value.profile_edit_type === 'prof_comment') {
        comment = 'プロフのコメントを変更しました';
      }
      else　if (value.profile_edit_type === 'prof_partner_comment') {
				comment = 'プロフのパートナーへ一言を変更しました';
			}

      contents = (
        <div style={{padding:'2%'}}>
          <div style={{margin:'5px'}}>
            { comment }
          </div>
        </div>
      );
    }
    else if (value.type === "proof") {

      title = this._renderTitle('single', value, '証明書を提出しました');

      let proof_type;
      if (value.proof_type === 'person') {
        proof_type = '本人証明';
      }
      else if (value.proof_type === 'photo') {
        proof_type = '写真証明';
      }
      else if (value.proof_type === 'income') {
        proof_type = '収入証明';
      }
      else if (value.proof_type === 'single') {
        proof_type = '独身証明';
      }

      contents = (
        <div style={{padding:'2%'}}>
          <div align='center' style={{margin:'5px',}}>
            <FeaturedPlayListOutlinedIcon  style={{fontSize:'6em', color:'#333'}} />

          </div>
          <div align='center' style={{margin:'5px', fontWeight:'bold', fontSize:'1.2em', color:'#333'}}>
            { proof_type } を提出しました
          </div>
        </div>
      );
    }
    else if (value.type === "photo" || value.type === "photoMain" || value.type === "photoSecret") {
      if (value.type === "photoMain") {
        title = this._renderTitle('single', value, 'メイン写真を掲載しました');
      }
      else if (value.type === "photoSecret") {
        title = this._renderTitle('single', value, 'シークレット写真を掲載しました');
      }
      else {
        title = this._renderTitle('single', value, '写真を掲載しました');
      }

      contents = (
        <div style={{padding:'2%'}}>
          <div align='center'>
            <LazyLoadImage
              src={ value.photo_file }
              style={{width:"160px", height: "160px", boxSizing:'border-box', borderRadius:'50%',}}
              placeholder={<img src={Blank} style={{width:"100%", height: "auto",}} alt='' />}
              alt=''
            />

          </div>
        </div>
      );
    }
    else {
      contents = (
        <div>
          <div style={{margin:'5px',fontWeight:'bold',color:'#666'}}>
            Q. {value.qa_question}
          </div>
          <div style={{margin:'5px'}}>
            A. {value.qa_answered}
          </div>
        </div>
      );
    }

    return (
      <div
        key={ index }
        style={{padding:'2% 0%'}}
      >
        <Box
          boxShadow={2}
          style={{background:'#FFF'}}
          className='round12'
        >
          <div>
            { title }
            <div>
              { contents }
            </div>
          </div>
        </Box>
      </div>
    )
  };

  _partnerQaQuestionAnswerAddSubmit(qaAnswerOpen) {

  }

	render() {
		return (
			<div id='timeline_block'>
        <h2 align='center'>タイムライン</h2>
        {
          (this.props.my.setting.timeline === 1) ? (
            <div>
              <div
                style={{
                  display:'flex',
                  flexDirection:'row',
                  alignItems:'center',
                  justifyContent: 'space-between',
                  margin: '10px',
                }}
              >
                <div>
                  <IconButton
                    onClick={ () => this.setState({dialogTimelineCondition: true}) }
                  >
                    <FilterListIcon />
                  </IconButton>
                </div>
                <div>
                  <span style={{color:'#666'}}>ページ{this.props.timeline.page}</span>
                  <IconButton
                    onClick={ () => this.props.timelineListGet(1) }
                  >
                    <RefreshIcon />
                  </IconButton>
                </div>
              </div>

              {
                (this.props.timeline.isList) ? (
                  <div>
                    {
                      (this.props.timeline.list.length > 0) &&
                      this.props.timeline.list.map(
                        (value, index) => this._render(value, index)
                      )
                    }
                  </div>
                ) : (
                  <div>
                    <Box
                      boxShadow={2}
                      style={{background:'#FFF'}}
                      className='round12'
                    >
                      <div style={{padding:'10px'}}>
                        <h2 align='center' >
                          <span className='i-b'>タイムラインは</span>
                          <span className='i-b'>見つかりませんでした</span>
                        </h2>
                        <div align='center'>
                          <span className='i-b'>タイムラインにはお気に入り登録した</span>
                          <span className='i-b'>会員の活動が表示されます</span>
                          <span className='i-b'>会員検索をしてお気に入りに登録してみましょう</span>

                        </div>
                        <div align='center'>
                          <Link to={{ pathname: '/search/'}}>
                            <Button
                              variant="outlined"
                              color="primary"
                            >
                              会員検索
                            </Button>
                          </Link>
                        </div>
                      </div>
                    </Box>
                  </div>
                )
              }
              <div style={{margin:'15px'}}>
                <PartPagingNextPrev
                  page={this.props.timeline.page}
                  isNext={this.props.timeline.isListNext}
                  onClick={ (e) => this._onPaging(e) }
                  style={{margin:'10px'}}
                />
              </div>

              <DialogQaAnswerAddConfirm
                open={ (this.state.qaAnswerAddQaId && this.state.qaAnswerAddText) ? true: false }
                pic={this.state.pic}
                answerAddQaId={this.state.qaAnswerAddQaId}
                answerAddText={this.state.qaAnswerAddText}
                apply={ (qaAnswerOpen) => this.props.partnerQaQuestionAnswerAdd(this.state.qaAnswerAddQaId, qaAnswerOpen, this.state.qaAnswerAddText, () => {
                    this.setState({qaAnswerAddQaId:null, qaAnswerAddText:''})
                  })
                }
                close={ () => this.setState({qaAnswerAddQaId: null, qaAnswerAddText:''}) }
              />

              <DialogConfirm
                open={ (this.state.qaAnswerDelQaId) ? true : false }
                title={'Q&Aの回答を削除'}
                content={'Q&Aの回答を削除してもいいですか？'}
                apply={ () => {
                  this.props.partnerQaQuestionAnswerDel(this.state.qaAnswerDelQaId, () => {
                    this.setState({qaAnswerDelQaId: null})
                  })
                }}
                close={ () => this.setState({qaAnswerDelQaId: null}) }
              />
              <DialogMyPostGoodUser />
              <DialogTimelineCondition
                open={ this.state.dialogTimelineCondition }
                close={ () => this.setState({dialogTimelineCondition: false}) }
              />

              <Menu
                anchorEl={this.state.timelineEditAnchor}
                keepMounted
                open={(this.state.timelineEditPic)? true: false}
                onClick={ () => this.setState({timelineEditPic: null}) }
              >
                <MenuItem
                  onClick={ () => {
                    this.props.favoriteMyDel(this.state.timelineEditPic, () => {
                      this.setState({timelineEditPic: null,timelineEditAnchor:null});
                    });
                  }}
                >
                  <div>
                      タイムラインから解除
                      <div style={{fontSize:'0.9em',color:'#666',maxWidth:'240px'}}>
                      　(お気に入りから解除する)
                      </div>
                  </div>
                </MenuItem>
              </Menu>
            </div>
          ):(
            <div>
              <h2 align='center' style={{padding:'30px 0px'}}>
                <span className='i-b'>あなたのタイムライン設定が非表示の為</span>
                <span className='i-b'>タイムラインは閲覧できません</span>
              </h2>
              <div align='center'>
                <Link to={{ pathname: '/setting/timeline/'}}>
                  <Button
                    variant="outlined"
                    color="primary"
                  >
                    タイムラインの設定
                  </Button>
                </Link>
              </div>
            </div>
          )
        }
        <div align='center' style={{margin:'15px'}}>
          <Button
            color="primary"
            variant={ "outlined" }
            onClick={ () => this.props.helpOpen('category','timeline') }
          >
            「タイムライン」とは？
          </Button>
        </div>

			</div>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		ui: state.ui,
    my: state.my,
    timeline: state.timeline,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...timelineAction,
    ...partnerAction,
    ...footprintAction,
    ...lightboxAction,
    ...favoriteAction,
    ...myPostGoodUserAction,
    ...helpAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
